import { render, staticRenderFns } from "./LogisticsPanel.vue?vue&type=template&id=18798f22&"
import script from "./LogisticsPanel.vue?vue&type=script&lang=js&"
export * from "./LogisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsPanel.vue?vue&type=style&index=0&id=18798f22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports